export default {"src":"/_next/static/media/lineGroupB.257281a5.svg","height":348,"width":1756,"blurWidth":0,"blurHeight":0};